module.exports = __webpack_public_path__ + "img/PC9.9ca6883c.png";